module.exports = __webpack_public_path__ + "img/37.7.Chla.52d595eb.png";